import { ServiceItem } from "@/types";
import { 
  BarChart3, 
  Database, 
  Users, 
  Bot, 
  ArrowRight 
} from "lucide-react";

const services: ServiceItem[] = [
  {
    icon: "BarChart3",
    title: "Analytics",
    description: "Advanced analytics models for marketing, experimentation, customer and product insights.",
    link: "#analytics"
  },
  {
    icon: "Database",
    title: "Data Engineering",
    description: "Building lake house and medallion architecture on modern data stack.",
    link: "#data-engineering"
  },
  {
    icon: "Users",
    title: "CDP",
    description: "Build out Customer Data Platforms for comprehensive customer 360 views.",
    link: "#cdp"
  },
  {
    icon: "Bot",
    title: "AI",
    description: "Deploy AI models using RAG and agentic frameworks for customer care and BI insights.",
    link: "#ai"
  }
];

const iconMap = {
  BarChart3: <BarChart3 className="h-8 w-8" />,
  Database: <Database className="h-8 w-8" />,
  Users: <Users className="h-8 w-8" />,
  Bot: <Bot className="h-8 w-8" />
};

const ServicesOverview = () => {
  return (
    <section id="services" className="py-20 bg-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive data solutions designed to transform your business
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="service-card bg-white rounded-lg shadow-lg p-6 border border-transparent hover:border-blue-600"
            >
              <div className="text-blue-600 text-4xl mb-4">
                {iconMap[service.icon as keyof typeof iconMap]}
              </div>
              <h3 className="text-xl font-bold mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-4">{service.description}</p>
              <a 
                href={service.link} 
                className="text-blue-600 font-medium inline-flex items-center"
              >
                Learn more <ArrowRight className="ml-2 h-4 w-4" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
